<template>
  <div class="upload-box" :class="{ 'upload-box--multi-size': showMultiSize }">
    <div class="upload-box__title">More files to upload?</div>

    <div
      class="upload-box__wrapper"
      :class="{ 'upload-box__wrapper--standard-artwork': isStandardArtwork }"
      @click="onUpload"
    >
      <span class="upload-box__label-title hidden-xs"> {{ dtfTypeDropText }} </span>
      <span v-if="printAsIs" class="upload-box__label-title visible-xs">
        {{ dtfTypeDropText }}
      </span>
      <span v-else class="upload-box__label-title visible-xs">
        Tap anywhere to choose your images
      </span>
      <div class="upload-box__action-buttons">
        <GangSheetBuilderContainer v-if="showGangSheetBuilderFeature" />
        <span
          class="upload-box__action"
          :class="{ 'upload-box__action--standard-artwork': isStandardArtwork }"
        >
          Choose files
        </span>
      </div>
      <a
        v-if="isUserSignedIn && !isMultiUpload"
        href="javascript:;"
        class="upload-box__dropzone-button"
        @click="onArtworkHistoryClick"
        @click.stop
      >
        My Design Library
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import GangSheetBuilderContainer from "./GangSheetBuilderContainer.vue";
import { useDtfStore } from "./store";

export default {
  name: "UploadBox",
  components: {
    GangSheetBuilderContainer
  },
  emits: ["upload"],
  computed: {
    ...mapState(useDtfStore, [
      "pdpType",
      "printAsIs",
      "dtfTypeDropText",
      "businessLine",
      "showMultiSize",
      "isStandardArtwork",
      "showGangSheetBuilderFeature",
      "userType",
      "showModal"
    ]),
    isUserSignedIn() {
      return this.userType === "signed_in";
    },
    isMultiUpload() {
      return this.showModal;
    }
  },
  methods: {
    ...mapActions(useDtfStore, ["setShowArtworkHistoryModal"]),
    trackAddFileAreaClick() {
      submitDtfEvent("transfer_choose_file_clicked", {
        page: "pdp",
        pdp_type: this.pdpType,
        business_line: this.businessLine
      });
    },
    onUpload() {
      this.trackAddFileAreaClick();
      this.$emit("upload");
    },
    onArtworkHistoryClick() {
      this.setShowArtworkHistoryModal(!this.showArtworkHistoryModal);
      submitDtfEvent("previous_purchase_link_clicked", {
        page: "pdp",
        pdp_type: this.pdpType
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.upload-box {
  $this: &;
  $dropzone-bg: #fdf2fa;
  $dropzone-highlight: #dd2672;
  $dropzone-hover: #c11574;

  color: $text-black;
  width: 100%;

  &--multi-size {
    #{$this}__title {
      font-size: 16px;
    }

    #{$this}__wrapper {
      outline: 8px solid $dropzone-bg;
      margin: 12px 8px;
      width: auto;
      border-radius: 4px;
    }
  }

  &__title {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
  }

  &__wrapper {
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 174px;
    margin-top: 8px;
    cursor: pointer;
    background: $spindle-light;
    border: 2px dashed $primary-light;
  }

  &__label-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
    margin-bottom: 12px;
  }

  &__tip {
    font-size: 14px;
    font-weight: 400;
    color: $warm-grey;
    line-height: 20px;
  }

  #{$this}__action {
    cursor: pointer;
    appearance: none;
    border: none;
    padding: 9px;
    margin: 0 0 3px;
    border-radius: 8px;
    background: $dropzone-highlight;
    width: 190px;
    height: 40px;
    color: $white;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: $dropzone-hover;
    }

    &--standard-artwork {
      background: $primary-light;

      &:hover {
        background: $primary;
      }
    }
  }

  #{$this}__wrapper {
    border: 1px dashed $dropzone-highlight;
    background: $dropzone-bg;
    box-shadow: 0 12px 12px -4px rgba(18, 25, 38, 0.08);

    &:hover {
      box-shadow: 0 0 10px $dropzone-highlight;
    }

    &--standard-artwork {
      border-color: $primary-light;
      background: $spindle-light;
      outline-color: $spindle-light;

      &:hover {
        box-shadow: 0 0 10px $primary-light;
      }
    }
  }

  &__action-buttons {
    display: flex;
    flex-direction: column-reverse;
    gap: 20px;

    @include with-desktop {
      flex-direction: row;
    }
  }

  #{$this}__dropzone-button {
    margin-top: 6px;
    background: transparent;
    border: none;
    height: unset;
    color: $primary-light;
    font-weight: 700;
    text-decoration: underline;

    &:hover {
      background: transparent;
    }
  }
}
</style>
